Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "styles1781672492",
  {"root":"styles1781672492--root","button":"styles1781672492--button","icon":"styles1781672492--icon","dropdown":"styles1781672492--dropdown"},
  ".styles1781672492--root{position:relative;padding:0 6px;cursor:pointer}.styles1781672492--button{display:flex;align-items:center;justify-content:space-between;color:#3899ec}.styles1781672492--icon{margin-top:6px;margin-left:3px}.styles1781672492--dropdown{position:absolute;left:0;min-width:120px;margin-left:-25%}",
  2,
  "styles1781672492"
);
__webpack_require__.stylable.$.register(exports.default)
